// Sub-categories for the "Client request" closure reason, so closures can be
// reported on by why the client asked. Stored as "Client request - <sub>":
// the backend matches reasons with startswith() and the payments screen
// with includes('client request'), so both keep working unchanged.
export const REASON_CLIENT_REQUEST = 'Client request';

export const CLIENT_REQUEST_SUB_REASONS = [
  'Multi-rep',
  'No reason given',
  'Client believed was making enquiry',
  'No signature/invalid signature',
  'Fraud',
  'Delay',
  "Won't provide ID/documentation",
  'Health Reasons',
] as const;

export const buildClientRequestReason = (subReason: string): string =>
  `${REASON_CLIENT_REQUEST} - ${subReason}`;

/** True when "Client request" is chosen but no sub-category yet. */
export const isClientRequestSubReasonMissing = (reason: string, subReason: string): boolean =>
  reason === REASON_CLIENT_REQUEST && !subReason;

/** The sub-category inside a stored "Client request - <sub>" reason, else null. */
export const splitClientRequestReason = (reason: string): string | null => {
  const prefix = `${REASON_CLIENT_REQUEST} - `;
  if (!reason.startsWith(prefix)) return null;
  const subReason = reason.slice(prefix.length);
  return (CLIENT_REQUEST_SUB_REASONS as readonly string[]).includes(subReason) ? subReason : null;
};
